import { render, staticRenderFns } from "./CategoriasUsuarioEdicionComponent.vue?vue&type=template&id=1566b9c2&"
import script from "./CategoriasUsuarioEdicionComponent.vue?vue&type=script&lang=js&"
export * from "./CategoriasUsuarioEdicionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasUsuarioEdicionComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports